import { useTranslation } from 'react-i18next'

import { Signin } from 'components'

import * as S from './styled'

const REQUEST_ACCESS_URL =
  'https://tracefasion.freshdesk.com/support/tickets/new?ticket_form=solicita%C3%A7%C3%A3o_de_acesso_%7C_trace_fashion'

export function AccessSuspended() {
  const { t } = useTranslation()

  function handleRequestAccess() {
    window.open(REQUEST_ACCESS_URL, '_blank', 'noopener,noreferrer')
  }

  return (
    <Signin>
      <S.SideBarCorner>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="138.11"
          height="395.5"
          viewBox="0 0 138.11 395.5"
          className="decoration"
        >
          <path
            fill="#3fab36"
            className="decorator_form"
            d="M138.11,212.143c0-56.625-22.787-78.15-36.5-107.314C92.441,85.312,93.41,0,93.41,0H0V395.5H93.41s1.552-61.884,8.206-76.042C115.324,290.293,138.11,268.769,138.11,212.143Z"
          />
        </svg>
        <p className="chevron">›</p>
      </S.SideBarCorner>
      <S.Container>
        <S.Logo />
        <S.Title>{t('accessSuspendedPage:title')}</S.Title>
        <S.Description>{t('accessSuspendedPage:description')}</S.Description>
        <S.RequestButton
          size="large"
          variant="green"
          onClick={handleRequestAccess}
        >
          {t('accessSuspendedPage:requestAccessButton')}
        </S.RequestButton>
      </S.Container>
    </Signin>
  )
}
